module.exports = __webpack_public_path__ + "media/theme/step--4--open-a561c330.png";